import { useCallback } from 'react';
import { captureEvent } from '../../lib/analytics';
import { CrisisSeverity } from './types-constants';
import { SafetyModalsAction } from './reducer';

export function useCrisisModal(dispatch: React.Dispatch<SafetyModalsAction>) {
  const triggerCrisisResources = useCallback(
    (severity?: CrisisSeverity) => {
      dispatch({ type: 'TRIGGER_CRISIS', payload: { severity } });

      captureEvent('Safety_ResourcesShown', {
        triggered_by: 'crisis_detection',
        severity: severity || 'medium',
        screen: 'modal',
      });
    },
    [dispatch]
  );

  const dismissCrisis = useCallback(() => {
    dispatch({ type: 'DISMISS_CRISIS' });
  }, [dispatch]);

  return {
    triggerCrisisResources,
    dismissCrisis,
  };
}
